import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { PartnerForm } from '../../PartnerForm'
import useMutationCreatePartner from '../../../api/hooks/useMutationCreatePartner'
import { PartnerFormValues } from '../../PartnerForm/components'
import { GameType } from '@/schema'
export function CreatePartnerForm() {
	const navigate = useNavigate()
	const { id } = useParams()

	const { mutate: createPartner } = useMutationCreatePartner({
		onSuccess: () => {
			toast.success('สร้างพาร์ทเนอร์สำเร็จ')
			navigate('/operator/partner')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleSubmit = (values: PartnerFormValues) => {
		createPartner({
			payload: {
				...values,
				createdByPlayerId: id!,
				rewards: Object.values(GameType).reduce(
					(acc, type) => {
						acc[type] = {
							ratio: 0,
							maxCreditAmount: 0,
						}
						return acc
					},
					{} as Record<
						GameType,
						{
							ratio: number
							maxCreditAmount: number
						}
					>,
				),
			},
		})
	}

	return <PartnerForm mode="create" onSubmit={handleSubmit} />
}
